














































































import 'reflect-metadata'
import { Component, Vue } from 'vue-property-decorator'
import { ViewDataFromEmailApi } from '@/api'
import NotificationWithOutExit from "@/components/common/notification/NotificationWithOutExit.vue"

@Component({
    components: {
        'common-notification-notification': NotificationWithOutExit
    }
})
export default class UnitTransfered extends Vue {
    loading: boolean = false
    
    isData: boolean = false
    username: string = ""
    email: string = ""
    readDate: string = ""
    projectName: string = ""
    transferDate: string = ""
    unitGroupList: any = []
    headerDate: string = ""

    projectLists = [] as any

    async mounted() {
        await this.SetGetReportEmailTransfer()
    }

    async SetGetReportEmailTransfer() {
        try {
            this.loading = true
            const qs = this.$route.query
            const projectId = qs.pid ?? ""
            const transferDate = qs.date ?? ""

            if (projectId === "" || transferDate === "") {
                this.notification('ไม่พบข้อมูล', 'warning') 
                this.loading = false
                return
            }

            const response = await ViewDataFromEmailApi.GetUnitTransfered({
                "projectId": projectId,
                "transferDate": transferDate
            })

            this.headerDate = qs.headdate as string
            this.username = `${response.userName}`
            this.email = `${response.email}`
            this.readDate = `${response.readDate}`
            this.projectName = `${response.projectCode} ${response.projectName}`
            this.unitGroupList = response.unitList
            this.loading = false
            this.isData = true

        } catch (error) {
            this.isData = false
            this.notification('ไม่พบข้อมูล', 'warning') 
        }
    }

    notification (text: string, status: string) {
        const child = this.$refs.refNotification as any
        child.openNotification(text, status)
    }
}
